import Dropdown from './../../node_modules/bootstrap/js/dist/dropdown.js';
import Collapse from './../../node_modules/bootstrap/js/dist/collapse.js';
import Alert from './../../node_modules/bootstrap/js/dist/alert.js';
import Offcanvas from './../../node_modules/bootstrap/js/dist/offcanvas.js';
import Button from './../../node_modules/bootstrap/js/dist/button.js';
import Tooltip from './../../node_modules/bootstrap/js/dist/tooltip.js';

import ModulesLoader from './modulesLoader';
import Toggle from './modules/toggle';
import Close from './modules/close';

const modules = {
    'toggle': Toggle,
    'close': Close
};

window.addEventListener('load', () => {
    const modulesLoader = new ModulesLoader(modules);
    modulesLoader.init();

    const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))

    tooltipTriggerList.map(tooltipTriggerEl => {
        return new Tooltip(tooltipTriggerEl)
    });
});
